import {SpaGlobalConfig} from '../../generated/core';
import {getClientlibsBaseUrl} from './getClientlibsBaseUrl';
import icons from '../../generated/icons.json';

interface Icons {
    [iconName: string]: string[];
}

export const getIconUrl = (
    iconName: string,
    variant: string,
    config: SpaGlobalConfig
) => {
    const variants = (icons as Icons)[iconName];
    if (variants && (variant === 'default' || variants.includes(variant))) {
        const baseUrl = getClientlibsBaseUrl(config);
        return `${baseUrl}/statics/icons/${iconName}/${variant}.svg`;
    }
    return undefined;
};
